export default __webpack_public_path__ + "static/media/miezeRightPaw.a09bbacb.png";